/**
 * BaB frequency selector relocate
 * Moves Awtomic's delivery-options block from the sticky footer to
 * immediately after the modal header (under "Build a Box").
 */
(function () {
  var HEADER_SELECTOR =
    '.bundleapp-modal__container--complete-screen--header-container';
  var OPTIONS_SELECTOR = '.awtomatic-bab-options-container';
  var LABEL_SELECTOR = '.bundle-text--subheading';
  var MOVED_ATTR = 'data-custom-bab-frequency-relocated';
  var LABEL_TEXT = 'Deliver every:';
  var scheduled = false;

  function isAfterHeader(options, header) {
    return header.nextElementSibling === options;
  }

  function setLabel(options) {
    var label = options.querySelector(LABEL_SELECTOR);
    if (label && label.textContent !== LABEL_TEXT) {
      label.textContent = LABEL_TEXT;
    }
  }

  function relocate() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header || !header.parentNode) return;

    var options = document.querySelector(OPTIONS_SELECTOR);
    if (!options) return;

    if (isAfterHeader(options, header)) {
      if (!options.hasAttribute(MOVED_ATTR)) {
        options.setAttribute(MOVED_ATTR, '');
      }
      setLabel(options);
      return;
    }

    header.insertAdjacentElement('afterend', options);
    options.setAttribute(MOVED_ATTR, '');
    setLabel(options);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      relocate();
    });
  }

  function init() {
    relocate();

    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
